export default {
  CRITICAL: 0,
  IMPORTANT: 1,
  NORMAL: 2,
  INSIGNIFICANT: 3,
};
